/* Warmtable core JS: helpers, cut-off dates, real Shopify cart + drawer, module init. Product modules live in wt-product.js. */
(() => {
  'use strict';
  const WT = (window.WT = window.WT || {});
  const $ = (WT.$ = (s, r = document) => r.querySelector(s));
  const $$ = (WT.$$ = (s, r = document) => [...r.querySelectorAll(s)]);
  const str = (WT.str = (k) => (WT.strings || {})[k] || '');
  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || WT.root || '/';
  const esc = (WT.esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])));
  WT.reduced = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  WT.money = (cents, cur) => {
    try { return new Intl.NumberFormat(WT.locale || 'en-US', { style: 'currency', currency: cur || WT.currency || 'USD' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  };
  const mods = (WT.mods = WT.mods || []);
  WT.register = (sel, fn) => mods.push([sel, fn]);

  /* Fixed cut-off dates from Brand settings; business-day delivery window. */
  const fmtDay = (d) => {
    try { return new Intl.DateTimeFormat(WT.locale || 'en-US', { month: 'short', day: 'numeric' }).format(d); }
    catch (e) { return new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' }).format(d); }
  };
  WT.cutoff = () => {
    const now = new Date();
    for (const c of WT.cutoffs || []) { const d = new Date(c.date + 'T23:59:59'); if (!isNaN(d) && now <= d) return fmtDay(d) + ' for ' + c.label; }
    return null;
  };
  const addBiz = (from, n) => { const x = new Date(from); let k = 0; while (k < n) { x.setDate(x.getDate() + 1); const w = x.getDay(); if (w && w < 6) k++; } return x; };
  function fillDates(scope) {
    const cut = WT.cutoff();
    $$('[data-wt-cutoff]', scope).forEach((el) => { const t = cut ? (el.dataset.tpl || '').replace('[cutoff]', cut) : el.dataset.fallback || ''; el.textContent = t; el.hidden = !t; });
    const e = WT.eta || [6, 12], now = new Date();
    $$('[data-wt-eta]', scope).forEach((el) => { el.textContent = (el.dataset.tpl || '').replace('[from]', fmtDay(addBiz(now, e[0]))).replace('[to]', fmtDay(addBiz(now, e[1]))); });
  }

  /* Cart API (respects market subfolders via Shopify.routes.root) */
  const api = async (path, body) => {
    const opts = body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } };
    const r = await fetch(root() + path, opts);
    const j = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(j.description || j.message || str('error'));
    return j;
  };
  WT.cart = { get: () => api('cart.js'), add: (items) => api('cart/add.js', { items }), change: (id, quantity) => api('cart/change.js', { id, quantity }) };

  const drawer = () => $('[data-wt-drawer]');
  let lastFocus = null;
  function render(c) {
    WT.currency = c.currency || WT.currency;
    $$('[data-wt-cart-count]').forEach((e) => (e.textContent = c.item_count));
    const d = drawer(); if (!d) return;
    const body = $('[data-wt-drawer-body]', d), foot = $('[data-wt-drawer-foot]', d), er = $('[data-wt-cart-error]', d);
    if (er) er.hidden = true;
    if (!c.item_count) {
      body.innerHTML = '<div class="wt-empty"><p>' + esc(str('empty')) + '</p><a class="wt-btn" href="' + esc(WT.shopUrl || root()) + '">' + esc(str('cont')) + '</a></div>';
      foot.hidden = true; return;
    }
    foot.hidden = false;
    body.innerHTML = c.items.map((i) => {
      const img = i.image ? i.image + (i.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
      const was = i.original_line_price > i.final_line_price ? '<s>' + WT.money(i.original_line_price) + '</s>' : '';
      const v = i.variant_title && !i.product_has_only_default_variant ? '<div class="wt-line__v">' + esc(i.variant_title) + '</div>' : '';
      const disc = (i.line_level_discount_allocations || []).map((a) => '<div class="wt-line__d">' + esc(a.discount_application && a.discount_application.title) + '</div>').join('');
      return '<div class="wt-line" data-key="' + esc(i.key) + '">' + (img ? '<img src="' + esc(img) + '" alt="" width="72" height="72" loading="lazy">' : '<span></span>') +
        '<div><a class="wt-line__t" href="' + esc(i.url) + '">' + esc(i.product_title) + '</a>' + v + disc +
        '<div class="wt-qty"><button type="button" data-q="' + (i.quantity - 1) + '" aria-label="' + esc(str('dec')) + '">−</button><span>' + i.quantity + '</span><button type="button" data-q="' + (i.quantity + 1) + '" aria-label="' + esc(str('inc')) + '">+</button></div>' +
        '<button type="button" class="wt-line__rm" data-q="0">' + esc(str('remove')) + '</button></div><div class="wt-line__p">' + was + WT.money(i.final_line_price) + '</div></div>';
    }).join('');
    $('[data-wt-subtotal]', d).textContent = WT.money(c.total_price);
    const sv = $('[data-wt-savings]', d);
    if (sv) { sv.hidden = !c.total_discount; sv.lastElementChild.textContent = '−' + WT.money(c.total_discount); }
    const note = $('[data-wt-cart-note]', d);
    if (note) { note.textContent = WT.cartNote || ''; note.hidden = !WT.cartNote; }
  }
  WT.renderCart = render;
  WT.refreshCart = async () => { try { render(await WT.cart.get()); } catch (e) {} };
  WT.openCart = (cart) => {
    const d = drawer();
    if (!d) { location.href = WT.cartUrl || root() + 'cart'; return; }
    lastFocus = document.activeElement;
    if (cart) render(cart); else WT.refreshCart();
    d.inert = false; d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('wt-lock');
    setTimeout(() => $('.wt-drawer__panel', d).focus(), 40);
  };
  WT.closeCart = () => {
    const d = drawer(); if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); d.inert = true;
    document.documentElement.classList.remove('wt-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  };
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-wt-cart-open]')) { e.preventDefault(); WT.openCart(); return; }
    if (e.target.closest('[data-wt-cart-close]')) { WT.closeCart(); return; }
    const q = e.target.closest('.wt-line [data-q]');
    if (q) {
      const line = q.closest('.wt-line'); line.style.opacity = 0.5;
      WT.cart.change(line.dataset.key, Math.max(0, +q.dataset.q)).then((c) => { render(c); const p = $('.wt-drawer__panel'); if (p) p.focus(); }).catch((err) => {
        const el = $('[data-wt-cart-error]'); if (el) { el.textContent = err.message; el.hidden = false; } line.style.opacity = 1;
      });
      return;
    }
    const pp = e.target.closest('[data-wt-pp]');
    if (pp) {
      e.preventDefault();
      const v = pp.parentElement.querySelector('video'); if (!v) return;
      if (v.paused) { v.play(); pp.classList.remove('is-paused'); pp.setAttribute('aria-label', str('pause')); }
      else { v.pause(); pp.classList.add('is-paused'); pp.setAttribute('aria-label', str('play')); }
    }
  });
  document.addEventListener('keydown', (e) => {
    const d = drawer(); if (!d || !d.classList.contains('is-open')) return;
    if (e.key === 'Escape') { WT.closeCart(); return; }
    if (e.key !== 'Tab') return;
    const f = $$('a[href],button:not([disabled]),input,select,[tabindex]:not([tabindex="-1"])', d).filter((x) => x.offsetParent !== null);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1], panel = $('.wt-drawer__panel', d);
    if (!d.contains(document.activeElement)) { e.preventDefault(); first.focus(); return; }
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* Announcement rotation: pauses on hover/focus, off for reduced motion */
  WT.register('[data-wt-ann]', (a) => {
    const msgs = $$('[data-wt-msg]', a).filter((m) => m.textContent.trim());
    if (msgs.length < 2 || WT.reduced) return;
    msgs.forEach((m, k) => (m.hidden = k > 0));
    let k = 0, paused = false;
    ['mouseenter', 'focusin'].forEach((ev) => a.addEventListener(ev, () => (paused = true)));
    ['mouseleave', 'focusout'].forEach((ev) => a.addEventListener(ev, () => (paused = false)));
    setInterval(() => { if (paused) return; msgs[k].hidden = true; k = (k + 1) % msgs.length; msgs[k].hidden = false; }, (+a.dataset.interval || 5) * 1000);
  });

  WT.init = (scope) => {
    try { fillDates(scope); } catch (e) {}
    mods.forEach(([sel, fn]) => $$(sel, scope).forEach((el) => { if (el.dataset.wtInit) return; el.dataset.wtInit = '1'; try { fn(el); } catch (e) { if (window.console) console.warn('[wt]', sel, e); } }));
    if (WT.reduced) $$('.wt-media video[autoplay]', scope).forEach((v) => { v.pause(); const b = v.parentElement.querySelector('[data-wt-pp]'); if (b) { b.classList.add('is-paused'); b.setAttribute('aria-label', str('play')); } });
  };
  document.addEventListener('DOMContentLoaded', () => { const d = drawer(); if (d) d.inert = true; WT.init(document); });
  document.addEventListener('shopify:section:load', (e) => WT.init(e.target));
})();